// A supplier's short name (owner, 2026-10-29: «Supplier names are too long.
// Show a short version (first 2–3 meaningful words), with the full name on
// hover or tap»). Romanized Chinese company names read
//   [province/city] [district] [town/street] TRADE NAME [industry words] [legal form]
// — e.g. "Chaozhou City Chao'an District Caitang Town Shunshuo Chucheng Hardware
// Products Factory" → "Shunshuo Chucheng". The full name stays in the title.

const LEGAL = /\b(co\.?,?\s*ltd\.?|co\.?|ltd\.?|limited|company|corp\.?|inc\.?|youxian\s+gongsi|gongsi|factory|business\s+department|trading\s+department|department|jingyingbu|shanghang|online\s+store|flagship\s+store|store|shop|firm|studio)\s*$/i;
// a place marker ends the address part: City, District, Town, Street, Zone …
// ("shi"/"qu" only near the start; sheng, xian, zhen, cun are also everyday name syllables, so never markers)
const MARKER = /^(city|district|town|street|jiedao|county|province|zone|village|area)$/i;
const SHORT_MARKER = /^(shi|qu)$/i;
// a fused one: Shenzhenshi, Futianqu
const FUSED = /^[A-Z][a-z]{2,}(shi|qu)$/;
// a leading region or city with no marker after it: "Huizhou Jinghe Technology"
const PLACES = new Set(['guangdong', 'zhejiang', 'jiangsu', 'fujian', 'shandong', 'hebei', 'henan', 'anhui', 'jiangxi', 'hunan', 'hubei', 'sichuan',
  'shenzhen', 'guangzhou', 'dongguan', 'foshan', 'huizhou', 'zhongshan', 'shantou', 'chaozhou', 'jieyang', 'yiwu', 'jinhua', 'ningbo', 'wenzhou',
  'hangzhou', 'taizhou', 'shanghai', 'beijing', 'tianjin', 'suzhou', 'xiamen', 'quanzhou', 'linyi', 'cangzhou', 'tengzhou', 'pujiang', 'longgang',
  'gaoyou', 'xindu', 'shaoxing', 'nanjing', 'qingdao', 'changsha', 'wuhan', 'chengdu', 'zhuhai', 'jiangmen', 'shunde', 'yongkang', 'huzhou', 'jiaxing']);
/** The short display name of a supplier: 2–3 meaningful words. */
export function shortSupplierName(full) {
  const name = String(full || '').replace(/\([^)]*\)/g, ' ').replace(/\s+/g, ' ').trim();
  if (!name) return '';
  let words = name.split(' ');
  // the address part ends at the last place marker among the first words
  let cut = -1;
  for (let i = 0; i < Math.min(words.length - 1, 8); i++) if (MARKER.test(words[i]) || (i < 4 && SHORT_MARKER.test(words[i])) || (i < 3 && FUSED.test(words[i]))) cut = i;
  if (cut >= 0) words = words.slice(cut + 1);
  else while (words.length > 1 && PLACES.has(words[0].toLowerCase())) words = words.slice(1);
  // the legal form at the end, possibly more than one ("Business Department", "Co., Ltd")
  let rest = words.join(' ');
  for (let k = 0; k < 3; k++) { const r = rest.replace(LEGAL, '').replace(/[,\s]+$/, ''); if (r === rest) break; rest = r; }
  words = rest.split(' ').filter(Boolean);
  // the trade name and what it makes: words until two of them and 8 letters, at most three
  const out = [];
  for (const w of words) {
    if (out.length >= 3) break;
    if (out.length >= 2 && out.join('').length >= 8) break;
    out.push(w);
  }
  return out.length ? out.join(' ') : name.split(' ').slice(0, 3).join(' ');
}
